/**
 * IMPORTANT: DEPRECATED
 * Apollo Cache Model Reducers
 *
 * These are the methods to update an item in the Apollo cache after a mutation occurs.
 */

import { FetchResult } from 'apollo-link';
import { ApolloQueryResult } from 'apollo-client';
import { DataProxy } from 'apollo-cache';
import { DocumentNode } from 'graphql';
import { pick } from 'lodash';

import { Content, Feed, GetFeedQueryVariables, GetContentQueryVariables } from 'api';

type ReducerArgs = (feedResult: Content, result: FetchResult['data']) => void;
type FeedResultArgs = (contentId: IReducer['contentId'], getFeed: Feed) => void;

interface IReducer {
  contentId: Content['content_id'];
  cache: DataProxy;
  result: FetchResult | ApolloQueryResult<{}>;
  query: DocumentNode;
  variables: GetFeedQueryVariables | GetContentQueryVariables;
}

interface IReducers {
  processContent: ReducerArgs;
  onMediaStatus: ReducerArgs;
}

// Reducers modify the result in-place
const reducers: IReducers = {
  processContent: (feedResult, result) => {
    Object.assign(feedResult, result);
  },
  onMediaStatus: (feedResult, result) => {
    const picked = pick(result, [
      'group_ids',
      'group_id_approvals',
      'content_object',
      'published_at',
    ]);
    Object.assign(feedResult, picked);
  },
};

// Find the getFeed.result being modified
const getFeedResult: FeedResultArgs = (contentId, getFeed) => {
  return getFeed.results.find((feedResult: Content) => {
    return feedResult.content_id === contentId;
  });
};

// TODO: Update reducers to use immer
export default (options: IReducer) => {
  const { contentId, cache, result, query, variables } = options;
  const { getContent, getFeed } = cache.readQuery({ query, variables });

  const queryResult = getContent || getFeedResult(contentId, getFeed);
  const mutations = Object.keys(result.data);

  if (!queryResult) {
    return;
  }

  mutations.forEach(mutation => {
    reducers[mutation](queryResult, result.data[mutation]);
  });

  cache.writeQuery({
    query,
    variables,
    data: { getFeed, getContent },
  });
};
